/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Suffix_LabelInputs */



/**
* | output |
* | --- |
* | "Suffix Character" |
*
* @param {Insert_Speaker_Suffix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_suffix_label = /** @type {((inputs?: Insert_Speaker_Suffix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Suffix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractère de suffixe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suffixzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carattere suffisso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Суффиксный символ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carácter de sufijo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("后缀字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接尾辞文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्यय वर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caractere de sufixo")
	return /** @type {LocalizedString} */ ("Suffix Character")
});